import { confirmTaxIdFieldConfig, taxIdFieldConfig } from "./_common";

export const latviaFields = {
  lvPersonasKods: taxIdFieldConfig("LV", "lvPersonasKods"),
  lvConfirmPersonasKods: confirmTaxIdFieldConfig("LV", "lvPersonasKods"),
};
